import { Component } from 'react';
import { GroupControl } from '../../../../GroupField';
import SubTypeField from '../Field';
import SubTypeControl from '../Control';

export default class SubTypeGroupField extends Component {
  render() {
    return (
      <SubTypeField
        {...this.props}
        component={GroupControl}
        FormControl={SubTypeControl}
      />
    );
  }
}
